<template>
  <button :disabled="loading" class="flex items-center">
    <div v-if="progress" class="text-white mr-2">{{ progress + '%' }}</div>
    <div v-if="loading" class="btn-spinner mr-2" />
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    loading: Boolean,
    progress: Number,
  },
};
</script>
